var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    height: 393,
    viewBox: "0 0 1366 393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.k{fill:#fff;}.a{stroke:#707070;}.b{clip-path:url(#a);}.c{fill:#ebf3fa;}.d{fill:#dceaff;}.e{fill:#9fc1f4;}.f{fill:#f0f6ff;}.g{opacity:0.7;}.h{fill:#bad4f4;}.i{fill:#dfebfd;}.j{fill:#c8dbf4;}.l{fill:#eef5ff;}.m{fill:#233862;}.n{fill:#aec3ff;}.o{fill:#ea8b49;}.p{fill:#ffa561;}.q{fill:#ffb27d;}.r{fill:#e2915a;}.s{fill:#9db0f4;}.t{fill:#c65447;}.u{fill:#ef8e4b;}.v{fill:#f79857;}.w{fill:#2e3552;}.x{fill:#ed7d2b;}.y{fill:#abddda;}.z{fill:#0f2549;}.aa{fill:#8e312d;}.ab{fill:#a9453d;}.ac{fill:#ed975d;}.ad{fill:#afcdfb;}.ae{fill:#95b3ef;}.af{fill:#142d5e;}.ag{fill:#2b478b;}.ah{fill:#77a4e5;}.ai{fill:#cde0fb;}.aj{fill:#f99746;}.ak{fill:#f9ddbf;}.al{fill:#163560;}.am{fill:#fca56b;}.an{fill:#2c3a64;}.ao{fill:#ed985f;}.ap{fill:#efcdaf;}.aq{fill:#ffc299;}.ar{fill:#212d4c;}.as{fill:#b24940;}.at{fill:#e0eafc;}.au{fill:#1c468a;}.av{fill:#0071f2;mix-blend-mode:color;isolation:isolate;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1366,
    height: 393,
    transform: "translate(0 131)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 -131)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.113 129)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1958.5,568.242c2.894,0,7.805,24.811,8.288,26.833,14.286,59.886,14.155,125.512-20.38,182.08-23.418,38.357-64.8,68.931-114.347,91.307-54.773,24.735-117.939,35.311-182.341,37.347-74.111,2.343-147.676-5.068-221.572-7.294-75.7-2.281-150.6,5.764-224.536,16.485-65.8,9.541-131.2,20.661-197.691,27.684-64.966,7.1-132.644,11.606-198.371,8.045-53.627-2.905-105-13.666-150.351-34.305-41.9-19.067-76.832-45.228-121.032-61.831a287.021,287.021,0,0,0-78.667-16.94c-26.321-2.029-52.347-.9-78.307-5.347-40.685-6.975-76.727-23.331-103.132-46.228-51.4-44.576-66.462-108.644-48.544-163.931a137.1,137.1,0,0,1,32.468-53.906Z",
    transform: "translate(-368.394 -549.787)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.501 38.202)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M350.456,676.456V869.505H135.085s-30.455-99.62,30.451-153.457C220.178,667.751,280.82,671.808,350.456,676.456Z",
    transform: "translate(267.683 -647.361)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M127.471,676.456V869.505h215.37s30.455-99.62-30.451-153.457C257.749,667.751,197.107,671.808,127.471,676.456Z",
    transform: "translate(408.683 -647.361)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1551.185,573.62c-27.184,4.066-53.925,10.5-80.831,16.026q-1.594.328-3.191.648H1696q-1.108-.746-2.229-1.473c-18.542-11.948-39.548-18.177-61.475-19.859C1605.42,566.9,1577.748,569.512,1551.185,573.62Z",
    transform: "translate(-736.234 -568.242)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.926 66.82)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 25.35,
    height: 24.593,
    rx: 7.234,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 23.153,
    height: 22.462,
    rx: 6.607,
    transform: "translate(1.098 1.065)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.993 2.785)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.157)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M806,846.481a.525.525,0,1,1,.525.525A.525.525,0,0,1,806,846.481Z",
    transform: "translate(-805.997 -845.956)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M822.7,850.2a.525.525,0,1,1,.2.714A.525.525,0,0,1,822.7,850.2Z",
    transform: "translate(-818.467 -848.937)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M836.667,862.268a.525.525,0,1,1-.157.726A.525.525,0,0,1,836.667,862.268Z",
    transform: "translate(-828.799 -858.116)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M842.989,880.328a.525.525,0,1,1-.525.525A.525.525,0,0,1,842.989,880.328Z",
    transform: "translate(-833.324 -871.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M838.216,900.537a.525.525,0,1,1-.742,0A.525.525,0,0,1,838.216,900.537Z",
    transform: "translate(-829.469 -886.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M825.06,913.728a.525.525,0,1,1-.743,0A.525.525,0,0,1,825.06,913.728Z",
    transform: "translate(-819.61 -896.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M806,919.417a.525.525,0,1,1,.525.525A.525.525,0,0,1,806,919.417Z",
    transform: "translate(-805.997 -900.611)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.997)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M790.271,850.2a.525.525,0,1,0-.2.714A.525.525,0,0,0,790.271,850.2Z",
    transform: "translate(-784.318 -849.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M776.309,862.268a.525.525,0,1,0,.156.726A.525.525,0,0,0,776.309,862.268Z",
    transform: "translate(-773.986 -859.113)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M769.986,880.328a.525.525,0,1,0,.525.525A.525.525,0,0,0,769.986,880.328Z",
    transform: "translate(-769.461 -872.71)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 0.525,
    cy: 0.525,
    r: 0.525,
    transform: "translate(1.29 12.644)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M787.916,913.728a.525.525,0,1,0,.743,0A.525.525,0,0,0,787.916,913.728Z",
    transform: "translate(-783.175 -897.623)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.533 5.365)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M807.526,880.853a.525.525,0,1,1,.525.526A.525.525,0,0,1,807.526,880.853Z",
    transform: "translate(-807.526 -874.293)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.454)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 0.143,
    height: 6.56
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.327 3.651)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 4.421,
    height: 0.43,
    transform: "matrix(0.786, -0.618, 0.618, 0.786, 0, 2.731)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(922.039 86.997)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 73.932,
    height: 135.146
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 67.531,
    height: 132.772,
    transform: "translate(3.246 2.374)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M2800.052,1177.142a2.985,2.985,0,1,1,2.985,2.985A2.984,2.984,0,0,1,2800.052,1177.142Z",
    transform: "translate(-2740.729 -1109.29)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.172 22.495)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 27.876,
    height: 8.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 17.53,
    height: 0.905,
    transform: "translate(5.173 2.728)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 12.622,
    height: 0.905,
    transform: "translate(7.627 5.166)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.837 22.159)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2654.48,1003.76v9.469h28.545v-9.469Zm27.876,8.8h-27.207v-8.131h27.207Z",
    transform: "translate(-2654.48 -1003.76)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(543.877 86.997)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 73.932,
    height: 135.146
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 67.531,
    height: 132.772,
    transform: "translate(3.245 2.374)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1525.974,1177.142a2.985,2.985,0,1,1,2.985,2.985A2.985,2.985,0,0,1,1525.974,1177.142Z",
    transform: "translate(-1466.652 -1109.29)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.171 22.495)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 27.876,
    height: 8.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 17.529,
    height: 0.905,
    transform: "translate(5.173 2.728)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 12.623,
    height: 0.905,
    transform: "translate(7.627 5.166)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.836 22.159)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1380.4,1003.76v9.469h28.547v-9.469Zm27.878,8.8h-27.209v-8.131h27.209Z",
    transform: "translate(-1380.4 -1003.76)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(223.833 86.997)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 73.932,
    height: 135.146
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 67.531,
    height: 132.772,
    transform: "translate(3.246 2.374)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M580.012,1177.142a2.985,2.985,0,1,1,2.985,2.985A2.985,2.985,0,0,1,580.012,1177.142Z",
    transform: "translate(-520.69 -1109.29)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1088.537 102.87)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M2820.487,1442.441h-6.619a16.041,16.041,0,0,1,.528-2.376,6.608,6.608,0,0,1,.375-.953c.644-1.285,4.732-.468,4.732-.468a3.147,3.147,0,0,1,.677,1.568A13.212,13.212,0,0,1,2820.487,1442.441Z",
    transform: "translate(-2786.934 -1323.168)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2748.756,1051.174s-5.276.926-6.467,4.039-7.93,53.4-7.93,53.4,3.336,2.643,10.5,1.694S2748.756,1051.174,2748.756,1051.174Z",
    transform: "translate(-2727.353 -1033.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M2719.96,1432.3a3.586,3.586,0,0,1-.458,2.089H2706.41a2.259,2.259,0,0,1,1.982-1.4,9.925,9.925,0,0,0,5.3-2.452,3.945,3.945,0,0,0,1.026-1.858c.616-2.742,5.092.84,5.092.84A22,22,0,0,1,2719.96,1432.3Z",
    transform: "translate(-2706.41 -1315.114)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M2735.266,1256.418c1.463.467,4.259,1.891,6.035,1.221,1.148-.432,7.565-18.995,7.981-27.114a20.83,20.83,0,0,1,.329-2.418c.38-2.1,1.045-4.975,1.811-8.152,2.054-8.513,4.831-19.163,4.771-22.567-.093-5.284-15.745-1.108-15.745-1.108a56.5,56.5,0,0,0-1.292,10.609c-.425,12.455-1.593,33.494-4.772,48.1A1.255,1.255,0,0,0,2735.266,1256.418Z",
    transform: "translate(-2727.353 -1140.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M2781.322,1199.751l8.274,59.97a16.185,16.185,0,0,0,6.461.175s2.422-31.895,2.22-39.606,1.739-20.632-.444-22.058S2781.322,1199.751,2781.322,1199.751Z",
    transform: "translate(-2762.546 -1142.913)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M2778.03,1051.473s-8.7-5.623-14.932-2.747a11.7,11.7,0,0,0-2.939,2.631c-2.255,2.485-6.66,41.947-6.66,41.947s12.505,4.236,24.532-1.437Z",
    transform: "translate(-2741.695 -1030.556)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2744.788,1050.6s-8.8,3.607-10,6.38-5.067,19.795-5.067,21.791,6.747.446,7.833-2.773c.9-2.673,3.944-10.886,5.549-16.081Z",
    transform: "translate(-2723.881 -1032.578)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.102)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M2792.861,1038.058a9.9,9.9,0,0,0,6.812-1.387,19.6,19.6,0,0,1-1.453-5.127c-.008-.061-.014-.12-.02-.176a5.38,5.38,0,0,1-.025-1.175h-4.967s-1.358.621-1.358,1.05q0,.345-.006.659c-.01.571-.032,1.07-.063,1.5a13.659,13.659,0,0,1-.254,2.051S2790.92,1037.678,2792.861,1038.058Z",
    transform: "translate(-2789.229 -1017.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M2792.812,1036.139a6.868,6.868,0,0,0,6.439-1.857c.07-.076.1-.12.1-.12-.04-.02-.082-.038-.125-.055-1.4-.568-4.581-.116-6.357.534C2792.865,1035.212,2792.842,1035.711,2792.812,1036.139Z",
    transform: "translate(-2790.258 -1020.021)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M2794.793,999.676c-.672,3.62-5.344,3.5-7.362,3.274-.567-.063-.925-.136-.925-.136-.641-.171-1-1.18-1.164-2.5a20.6,20.6,0,0,1,.528-7.437c.665-1.477,1.917-3.075,6.622-1.923S2795.657,995.038,2794.793,999.676Z",
    transform: "translate(-2784.573 -987.582)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M2783.749,981.955a10.744,10.744,0,0,1,3.245-2.648c2.659-1.439,6.063.045,6.078.052,3.842,1.689,4.845,4.629,2.808,9.208-2.154,4.842-4.205,4.3-4.205,4.3s.436-.271.4-1.78c0-.086-.007-.158-.01-.219a1.015,1.015,0,0,1,.321-.826c.477-.426.71-1.714.31-2.073-.482-.432-1.16.093-1.376.5a.589.589,0,0,1-.842.186c-1.2-.756-.42-2.268-1.563-3.193s-3.461-.148-5.176-.886C2781.491,983.735,2783.264,982.625,2783.749,981.955Z",
    transform: "translate(-2782.625 -978.679)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2784.72,1111.924q1.136.293,2.252.478c.659.112,1.314.2,1.971.251a32.045,32.045,0,0,0,11.829-1.453q1.475-.423,3.055-.957c.112-.038-.287-11.591-.748-23.508-.047-1.23-.1-2.465-.143-3.692q-.032-.78-.062-1.552c-.418-10.54-.833-20.058-.92-20.571-.2-1.16-.386-2.149-.59-3.005-.6-2.5-1.334-3.866-2.946-5.044-.157-.119-1.446-.769-2.582-1.334-.942-.468-1.78-.876-1.78-.876h0a4.978,4.978,0,0,0-1.3,2.248,81.24,81.24,0,0,0-2.448,8.165.073.073,0,0,0,0,.013h0c-.418,1.641-.718,2.918-.8,3.285-.145.62-.337,1.818-.562,3.442-.307,2.211-.672,5.212-1.058,8.617-.04.35-.08.705-.12,1.063-.046.408-.093.821-.139,1.239-.015.134-.03.268-.043.4-.148,1.348-.3,2.74-.448,4.155-.124,1.169-1.9,2.015-2.021,3.2-.07.7-.218,7.143-.407,9.2C2784.57,1097.165,2784.666,1111.234,2784.72,1111.924Z",
    transform: "translate(-2765.03 -1032.621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M2799.96,1108.55c.006.024.3,10.658-7.7,11.95s-2.685,1.633-2.685,1.633,15.05-.639,15.3-1.037S2799.96,1108.55,2799.96,1108.55Z",
    transform: "translate(-2767.438 -1076)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M2809.21,1168s.151.106.439.292a.1.1,0,0,1,.014.009,37.554,37.554,0,0,0,10.115,4.326q.831.226,1.716.423c-.048-1.23-.1-2.465-.143-3.691a15.458,15.458,0,0,0,1.982-.274c-.021-.162-.042-.324-.063-.486-.671-.275-1.338-.541-1.98-.792-.524-.2-1.03-.4-1.511-.58-2.166-.823-3.772-1.38-3.772-1.38l-6.412,2.031Z",
    transform: "translate(-2783.444 -1118.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2802.439,1081.507s.823.206,2.135.47l.014,0a52.507,52.507,0,0,0,10.116,1.132c.536-.006,1.063-.027,1.572-.067a15.485,15.485,0,0,0,1.983-.274,6.169,6.169,0,0,0,3.166-1.5c5.4-5.5-2.948-25.253-4.7-27.175-2.049-2.243-5.792-3.031-7.857-3.3l-.249-.032c-.727-.086-1.193-.1-1.219-.105h0s.162.521.433,1.4c.105.342.228.738.361,1.18,1.27,4.156,3.718,12.323,4.8,16.928a11.676,11.676,0,0,1,.511,3.254c-.421,1.573-4.786,2.382-7.552,2.739-1.154.149-2.029.22-2.226.235a.27.27,0,0,0-.04,0l-.16.656-.383,1.573-.377,1.545Z",
    transform: "translate(-2778.371 -1032.621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M2731.063,1140.03l18.555-.782-3.764-23.123-18.555.782Z",
    transform: "translate(-2722.063 -1081.676)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M2795.949,1153.271s-3.612-.252-3.793.59c-.423,1.963,3.1,3.574,4.249,3.464S2796.78,1153.14,2795.949,1153.271Z",
    transform: "translate(-2770.638 -1109.486)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M2729.8,1136.231s3.456-1.08,3.827-.3c.865,1.811-2.194,4.2-3.331,4.352S2728.964,1136.3,2729.8,1136.231Z",
    transform: "translate(-2723.553 -1096.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M2810.637,1046.03a6.741,6.741,0,0,1,2.281,1.817s-5.679,9.861-5.654,9.769S2809.183,1047.293,2810.637,1046.03Z",
    transform: "translate(-2781.986 -1029.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M2785.467,1046.585a4.331,4.331,0,0,0-1.676,1.715l-.675,8.609s1.441-6.318,2.176-9.174A4.789,4.789,0,0,0,2785.467,1046.585Z",
    transform: "translate(-2763.891 -1029.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M2754.615,1115.446a.843.843,0,0,0-.991-.567c-.845.074-5.589.308-5.589.308s-.916-.015-.831.571Z",
    transform: "translate(-2736.975 -1080.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M2790.943,1028.668a1.98,1.98,0,0,1-1.609.387c-.589-.1-.919-.87-.919-.87A4.447,4.447,0,0,1,2790.943,1028.668Z",
    transform: "translate(-2767.862 -1015.757)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(929.225 165.594)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M1627.843,1266.38l-3.872-30.1a6.435,6.435,0,0,1,6.261-7.348h108.025a9.518,9.518,0,0,1,9.135,7.165l7.628,28.611Z",
    transform: "translate(-1623.915 -1228.936)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M1667.237,1266.38l-3.873-30.1a6.435,6.435,0,0,1,6.262-7.348h108.025a9.519,9.519,0,0,1,9.135,7.165l7.628,28.611Z",
    transform: "translate(-1653.435 -1228.936)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 134.751,
    height: 16.703,
    rx: 8.351,
    transform: "translate(3.928 24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 127.014,
    height: 16.703,
    rx: 8.351,
    transform: "translate(25.543 24.95)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.854 41.653)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M1704.46,1410.021h0a1.354,1.354,0,0,1-1.312-1.578l2.031-13.32h3.642l-3.583,14.277A.808.808,0,0,1,1704.46,1410.021Z",
    transform: "translate(-1703.131 -1395.124)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140.979 41.653)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M2190.76,1410.021h0a1.354,1.354,0,0,0,1.313-1.578l-2.031-13.32H2186.4l3.582,14.277A.809.809,0,0,0,2190.76,1410.021Z",
    transform: "translate(-2186.4 -1395.124)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125.961 41.653)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M2130.842,1410.021h0a1.354,1.354,0,0,0,1.312-1.578l-2.031-13.32h-3.642l3.583,14.277A.808.808,0,0,0,2130.842,1410.021Z",
    transform: "translate(-2126.481 -1395.124)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.773 41.653)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M1652.267,1410.021h0a1.354,1.354,0,0,1-1.312-1.578l2.031-13.32h3.642l-3.583,14.277A.808.808,0,0,1,1652.267,1410.021Z",
    transform: "translate(-1650.938 -1395.124)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(115.137 116.164)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 26.239)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.907 37.775)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M838.3,1318.2h.056a.755.755,0,0,0,.763-.807l-3.031-30.272-2.645.236,4.352,30.435A.492.492,0,0,0,838.3,1318.2Z",
    transform: "translate(-833.444 -1287.123)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.756 37.775)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M733.917,1318.2h-.056a.755.755,0,0,1-.762-.807l3.031-30.272,2.645.236-4.352,30.435A.492.492,0,0,1,733.917,1318.2Z",
    transform: "translate(-733.096 -1287.123)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.292 37.775)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M923.623,1318.2h.055a.755.755,0,0,0,.762-.807l-3.031-30.272-2.645.236,4.353,30.435A.492.492,0,0,0,923.623,1318.2Z",
    transform: "translate(-918.765 -1287.123)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M723.59,1169.779l-5.381-26.57a5.888,5.888,0,0,1,6.161-6.8l10.377.237a8.2,8.2,0,0,1,7.687,5.918l7.872,27.214Z",
    transform: "translate(-718.11 -1136.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M736.578,1169.779l-5.38-26.57a5.888,5.888,0,0,1,6.161-6.8l10.377.237a8.2,8.2,0,0,1,7.687,5.918l7.872,27.214Z",
    transform: "translate(-727.842 -1136.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M2.423,0H41.63a2.423,2.423,0,0,1,2.423,2.423V4.846a0,0,0,0,1,0,0H2.423A2.423,2.423,0,0,1,0,2.423v0A2.423,2.423,0,0,1,2.423,0Z",
    transform: "translate(49.534 38.217) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 28.588,
    height: 4.846,
    rx: 2.423,
    transform: "translate(53.625 38.217) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.046)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M832.868,1141.615l4.361,11.035s4.2,4.952,7.579,3.356l-10.686-20.751Z",
    transform: "translate(-809.152 -1109.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M949.351,1376.646c-.126,1.219,1.57,1.534,3.537,1.653s1.368.516,4.06,1.033,3.78-.209,3.979-.571c.177-.322-1.071-.841-2.4-1.426q-.251-.11-.5-.224c-1.5-.677-2.326-2.035-3.485-3.3-1.1-1.2-2.112-5-2.112-5l-3.657-.822s.993,3.425,1.334,4.886a4.516,4.516,0,0,1-.4,2.541A4.8,4.8,0,0,0,949.351,1376.646Z",
    transform: "translate(-896.004 -1283.708)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M954.607,1400.5c1.967.119,1.368.516,4.06,1.033s3.781-.209,3.98-.571c.177-.321-1.071-.841-2.4-1.426l-.021.023a7.679,7.679,0,0,1-4.086,0c-1.779-.5-3.493-1.588-4.718-1.946a4.812,4.812,0,0,0-.35,1.229C950.944,1400.068,952.64,1400.382,954.607,1400.5Z",
    transform: "translate(-897.723 -1305.911)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M823.548,1200.822c-1.967-1.382-14.733-7.443-21.375-8.155l-7.592-2.775s-6.249,9.255-6.3,16.336c-.023,3.3,1.5,3.63,1.5,3.63s23.534.174,24.566.281c1.689.174,3.916,4.38,4.473,8.212s10.37,19.414,10.37,19.414a12.315,12.315,0,0,0,2.993.6,2.989,2.989,0,0,0,1.489-.4S827.985,1203.937,823.548,1200.822Z",
    transform: "translate(-775.741 -1150.248)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M925.064,1376.646c-.126,1.219,1.57,1.534,3.537,1.653s1.368.516,4.06,1.033,3.78-.209,3.98-.571c.177-.322-1.071-.841-2.4-1.426q-.251-.11-.5-.224c-1.5-.677-2.326-2.035-3.485-3.3-1.1-1.2-2.112-5-2.112-5l-3.657-.822s.993,3.425,1.334,4.886a4.515,4.515,0,0,1-.4,2.541A4.777,4.777,0,0,0,925.064,1376.646Z",
    transform: "translate(-877.804 -1283.708)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M930.32,1400.5c1.967.119,1.368.516,4.059,1.033s3.78-.209,3.979-.571c.178-.321-1.071-.841-2.4-1.426l-.021.023a7.679,7.679,0,0,1-4.086,0c-1.779-.5-3.492-1.588-4.718-1.946a4.807,4.807,0,0,0-.35,1.229C926.657,1400.068,928.353,1400.382,930.32,1400.5Z",
    transform: "translate(-879.523 -1305.911)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M808.744,1200.822c-1.708-1.2-6.009-1.745-12.261-3.781-1.506-.491-7.3-3.285-7.685-4.821l2.859-1.32-11.879-1.008a31.8,31.8,0,0,0-3.055,12.906c-.023,3.3,2.9,7.059,2.9,7.06s18.891.174,19.923.281c1.689.174,3.916,4.38,4.473,8.212s10.37,19.414,10.37,19.414a12.312,12.312,0,0,0,2.993.6,2.988,2.988,0,0,0,1.489-.4S813.181,1203.937,808.744,1200.822Z",
    transform: "translate(-767.078 -1150.248)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M762.246,1032.909a14.938,14.938,0,0,0-5.022-1.142c-5.366-.721-8.6,7.077-8.785,9.438-.35,4.355-2.654,5.019-5.9,7.746-6.5,5.468-4.6,11.822-1.04,14.183,2.133,1.417,5.893,0,5.893,0,.053.037,10.283-5.718,15.325-8.495C770.279,1053.565,766.868,1035.336,762.246,1032.909Z",
    transform: "translate(-738.244 -1031.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M808.092,1090.273a6.665,6.665,0,0,1-4.122.533c-1.635-.539-3.075-3-3.052-3,.71-.1,1.431-.8,1.633-4.951l.314.079,5.284,1.336s-.209,1.674-.3,3.257C807.78,1088.85,807.795,1090.115,808.092,1090.273Z",
    transform: "translate(-785.209 -1070.035)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M813.524,1085.573s0,.344-.2,1.9c-2.988-.754-4.306-1.745-5.236-2.879Z",
    transform: "translate(-790.584 -1071.344)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M809.368,1054.764s-6.988,1.138-7.629-3.225-1.975-7.153,2.459-8.064,5.548.626,6.116,2.03S811.169,1054.355,809.368,1054.764Z",
    transform: "translate(-785.301 -1040.323)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M803.705,1041.231s-3.173,5.009-6.006,6.2-4.224.584-4.224.584a11.927,11.927,0,0,0,1.624-4.578,2.147,2.147,0,0,1,1.327-1.726C798.459,1040.893,802.391,1039.609,803.705,1041.231Z",
    transform: "translate(-779.632 -1038.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M823.171,1041.491a11.056,11.056,0,0,1,2.626,1.847,8.5,8.5,0,0,1,1.532,4.253s.917-5.036-.994-6.768C824.309,1038.989,823.171,1041.491,823.171,1041.491Z",
    transform: "translate(-801.885 -1038.038)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M795.551,1114.13c-.212,14.2,5.023,10.227,3.469,11.576-.375.324-1.907,2.742-7.685,3.029-4.359.217-12.219-1.841-12.51-2.646-1-2.785-.3-3.65-1.133-7.914-.087-.453-.2-.944-.322-1.479-.7-2.928-1.379-3.925,1.1-8.629,2.248-4.262,4.892-7.724,5.1-7.6,5.932,3.521,6.135.57,6.135.57S795.655,1107.2,795.551,1114.13Z",
    transform: "translate(-767.078 -1083.235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M828.527,1102.752s6.071,1.029,6.788,3.657,7.722,22.515,7.722,22.515-7.472.2-8.9-1.23-3.407-17.384-3.407-17.384Z",
    transform: "translate(-805.899 -1084.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M835.026,1199.044a8.309,8.309,0,0,0,1.2,1.3.883.883,0,0,0,.486.1l-.607-1.092Z",
    transform: "translate(-810.769 -1157.106)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M834.2,1194.272l2.618,1.271a.467.467,0,0,1-.434.167,6.215,6.215,0,0,1-1.135-.312Z",
    transform: "translate(-810.147 -1153.531)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M828.581,1099.053l-.054.927c.69,2.372,1.857,9.7,3.31,15.375l1.016-8.122-.836-.682.313-1.149-2.737-5.195Z",
    transform: "translate(-805.899 -1082.177)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M775.045,1149.032c-9.363,3.133-13.476,1.212-13.476,1.212l1.53-9.052.835-4.937,1.792-10.6,3.059-10.075,2.677-1.621,2.336,11.7.615,11.5.029.553Z",
    transform: "translate(-755.723 -1093.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M766.07,1165.023a5.932,5.932,0,0,0,4.371,6.237c4.535,1.178-6.641,2.324-6.641,2.324s-3.6-2.766-3.552-3.444S766.07,1165.023,766.07,1165.023Z",
    transform: "translate(-754.733 -1131.612)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M779.016,1204.366a32.09,32.09,0,0,1-11.343,3.478l.835-4.937,10.479.906Z",
    transform: "translate(-760.297 -1160.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M814.287,1194.579s4.3-.957,4.99-.575a10.1,10.1,0,0,1,2.6,2.253c.212.483-1.543-.367-2.114-.52a5.083,5.083,0,0,0-1.825.4,6.069,6.069,0,0,1-3.27.329Z",
    transform: "translate(-795.228 -1153.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M761.5,1100.478s-6.081.355-8.079,3.141c-2.811,3.921-8.388,20.632-5.192,22.861,3.6,2.51,16.382.657,16.382.657s.425-1.988-.166-2.95-10.21-2.516-10.654-2.959,5.549-8.656,5.549-9.988S761.5,1100.478,761.5,1100.478Z",
    transform: "translate(-745.011 -1083.245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M799.06,1097.362l1.232,15.858-2.82-6.072.483-1.081a17.254,17.254,0,0,1-1.031-1.985c0-.209.293-5.769.293-5.769Z",
    transform: "translate(-782.217 -1080.91)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 8.095,
    height: 0.526,
    transform: "translate(28.972 42.745)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.639 22.64)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M892.935,1138.616h-24.65l4.479-16.566h24.651Z",
    transform: "translate(-868.284 -1122.051)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M896.041,1138.616H871.391l4.479-16.566H900.52Z",
    transform: "translate(-870.612 -1122.051)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M912.4,1171.565l-5.168.047L910.8,1160.7l5.169-.048Z",
    transform: "translate(-897.466 -1150.981)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "af",
    width: 11.288,
    height: 0.52,
    transform: "translate(6.568 20.111)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.855 159.442)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 139.322,
    height: 59.551,
    transform: "translate(4.48 3.367)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 148.282,
    height: 4.869,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 139.322,
    height: 9.616,
    transform: "translate(4.48 42.759)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(709.807 70.88)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 69.958,
    height: 49.514,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 19.529,
    height: 17.464,
    transform: "translate(5.432 3.888)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 18.959,
    height: 10.937,
    transform: "translate(43.713 33.059)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.202 4.55)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.558,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.882,
    transform: "translate(17.593)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.882,
    transform: "translate(25.919)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.202 7.198)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.558,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.882,
    transform: "translate(17.593)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.882,
    transform: "translate(25.919)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.202 9.845)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.558,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.882,
    transform: "translate(17.593)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.882,
    transform: "translate(25.919)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.202 15.263)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.558,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.882,
    transform: "translate(17.593)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.882,
    transform: "translate(25.919)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.202 17.91)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.558,
    height: 0.883
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.883,
    transform: "translate(17.593)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.883,
    transform: "translate(25.919)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.202 20.558)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.558,
    height: 0.883
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.883,
    transform: "translate(17.593)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.883,
    transform: "translate(25.919)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.432 33.233)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 9.946,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.882,
    transform: "translate(26.232)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.882,
    transform: "translate(11.156)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 5.557,
    height: 0.882,
    transform: "translate(19.529)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.432 35.88)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.759,
    height: 0.883
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.883,
    transform: "translate(17.806)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.883,
    transform: "translate(26.232)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.432 25.975)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 9.946,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.882,
    transform: "translate(26.232)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 23.408,
    height: 0.882,
    transform: "translate(34.538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.882,
    transform: "translate(11.156)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 5.557,
    height: 0.882,
    transform: "translate(19.529)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.432 28.623)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.759,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 14.557,
    height: 0.882,
    transform: "translate(17.806)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 9.731,
    height: 0.882,
    transform: "translate(33.37)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.882,
    transform: "translate(44.516)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.432 38.528)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 13.184,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.882,
    transform: "translate(26.232)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 9.687,
    height: 0.882,
    transform: "translate(14.686)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.432 41.274)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.759,
    height: 0.883
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.883,
    transform: "translate(17.806)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.883,
    transform: "translate(26.232)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1165.356 70.88)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 69.958,
    height: 49.514,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 19.529,
    height: 17.464,
    transform: "translate(5.432 3.888)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 18.959,
    height: 10.937,
    transform: "translate(43.713 33.059)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.202 4.55)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.558,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.882,
    transform: "translate(17.593)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.882,
    transform: "translate(25.919)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.202 7.198)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.558,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.882,
    transform: "translate(17.593)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.882,
    transform: "translate(25.919)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.202 9.845)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.558,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.882,
    transform: "translate(17.593)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.882,
    transform: "translate(25.919)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.202 15.263)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.558,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.882,
    transform: "translate(17.593)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.882,
    transform: "translate(25.919)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.202 17.91)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.558,
    height: 0.883
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.883,
    transform: "translate(17.593)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.883,
    transform: "translate(25.919)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.202 20.558)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.558,
    height: 0.883
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.883,
    transform: "translate(17.593)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.295,
    height: 0.883,
    transform: "translate(25.919)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.432 33.233)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 9.946,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.882,
    transform: "translate(26.232)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.882,
    transform: "translate(11.156)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 5.557,
    height: 0.882,
    transform: "translate(19.529)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.432 35.88)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.759,
    height: 0.883
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.883,
    transform: "translate(17.806)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.883,
    transform: "translate(26.232)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.432 25.975)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 9.946,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.882,
    transform: "translate(26.232)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 23.408,
    height: 0.882,
    transform: "translate(34.538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.882,
    transform: "translate(11.156)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 5.557,
    height: 0.882,
    transform: "translate(19.529)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.432 28.623)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.759,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 14.557,
    height: 0.882,
    transform: "translate(17.806)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 9.731,
    height: 0.882,
    transform: "translate(33.37)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.882,
    transform: "translate(44.516)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.432 38.528)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 13.184,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.882,
    transform: "translate(26.232)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 9.687,
    height: 0.882,
    transform: "translate(14.686)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.432 41.274)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.759,
    height: 0.883
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.883,
    transform: "translate(17.806)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.383,
    height: 0.883,
    transform: "translate(26.232)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(819.749 70.88)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 34.979,
    height: 49.514,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 13.364,
    height: 16.67,
    transform: "translate(19.263 3.888)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.104 4.109)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 8.661,
    height: 0.882,
    transform: "translate(0 19.195)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 13.491,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 13.491,
    height: 0.882,
    transform: "translate(0 3.824)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.736)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.6,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 5.68,
    height: 0.882,
    transform: "translate(8.351)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.912)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 5.406,
    height: 0.883
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 5.406,
    height: 0.883,
    transform: "translate(6.745)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(22.841 19.195)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(9.714 19.195)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 4.839,
    height: 0.882,
    transform: "translate(17.005 19.195)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.104 25.952)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 14.593,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(15.505)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(22.841)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.104 28.599)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 11.479,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(22.841)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 8.434,
    height: 0.882,
    transform: "translate(12.788)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.104 31.345)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 14.593,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(15.505)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(22.841)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.104 35.813)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 8.661,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(22.841)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(9.714)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 4.839,
    height: 0.882,
    transform: "translate(17.005)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.104 38.461)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 14.593,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(15.505)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(22.841)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.104 41.108)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 11.479,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(22.841)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 8.434,
    height: 0.882,
    transform: "translate(12.788)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.104 43.854)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 14.593,
    height: 0.883
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.883,
    transform: "translate(15.505)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.883,
    transform: "translate(22.841)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 70.88)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 34.979,
    height: 49.514,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 13.364,
    height: 16.67,
    transform: "translate(19.263 3.888)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.104 4.109)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 8.661,
    height: 0.882,
    transform: "translate(0 19.195)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 13.491,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 13.491,
    height: 0.882,
    transform: "translate(0 3.824)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.736)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.6,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 5.68,
    height: 0.882,
    transform: "translate(8.351)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.912)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 5.406,
    height: 0.883
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 5.406,
    height: 0.883,
    transform: "translate(6.745)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(22.841 19.195)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(9.714 19.195)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 4.839,
    height: 0.882,
    transform: "translate(17.005 19.195)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.104 25.952)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 14.593,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(15.505)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(22.841)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.104 28.599)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 11.479,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(22.841)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 8.434,
    height: 0.882,
    transform: "translate(12.788)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.104 31.345)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 14.593,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(15.505)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(22.841)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.104 35.813)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 8.661,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(22.841)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(9.714)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 4.839,
    height: 0.882,
    transform: "translate(17.005)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.104 38.461)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 14.593,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(15.505)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(22.841)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.104 41.108)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 11.479,
    height: 0.882
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.882,
    transform: "translate(22.841)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 8.434,
    height: 0.882,
    transform: "translate(12.788)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.104 43.854)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 14.593,
    height: 0.883
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.883,
    transform: "translate(15.505)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 6.429,
    height: 0.883,
    transform: "translate(22.841)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(848.849 18.663)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.32,
    height: 5.041,
    transform: "translate(0 21.863)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 0.524,
    height: 21.863,
    transform: "translate(8.015 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 0.524,
    height: 21.863,
    transform: "translate(47.845 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1199.507 18.663)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.32,
    height: 5.041,
    transform: "translate(0 21.863)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 0.524,
    height: 21.863,
    transform: "translate(8.015 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 0.524,
    height: 21.863,
    transform: "translate(47.845 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(584.404 21.088)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.32,
    height: 5.041,
    transform: "translate(0 19.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1325.584,680.53v12.384h-.524V680.6C1325.235,680.58,1325.411,680.555,1325.584,680.53Z",
    transform: "translate(-1317.045 -673.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1484.494,652.38v19.439h-.524V652.488C1484.145,652.45,1484.319,652.415,1484.494,652.38Z",
    transform: "translate(-1436.126 -652.38)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.181 26.537)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.32,
    height: 5.041,
    transform: "translate(0 13.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M669.54,678.73v12.8h.524V678.68Z",
    transform: "translate(-661.526 -677.537)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M828.984,674.13v13.981h-.524V674.12C828.636,674.122,828.808,674.127,828.984,674.13Z",
    transform: "translate(-780.615 -674.12)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1178.231 182.61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.037 15.711)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M255.1,1366.172s-2.753-3.212-.17-5.252a7.326,7.326,0,0,1,3.426-1.049s-2.18,3.656-1.475,4.019,2.136-4.249,2.136-4.249,4.294-.416,5.676.248c0,0-3.671,3-2.9,3.183s4.738-2.77,4.738-2.77,4,.68,3.784,3.118-1.59,3.191-2.2,3.126-4.146-1.416-4.223-.921,2.054,2.117,3.547,2.193c0,0-2.818,3.107-4.69,2.21s-2.033-2.318-3.2-2.851-2.164-.532-1.682.012,2.595,1.072,3.262,2.253,1.267,1.977-.671,1.686-5.087-1.709-5.225-3.333Z",
    transform: "translate(-250.444 -1359.512)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.955)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M264.941,1375.31s-10.855-.418-13.252,2.687a7.852,7.852,0,0,1-2.161,3.033l-.254.693s1.881-1.983,2.554-2.1C251.827,1379.62,250.774,1375.774,264.941,1375.31Z",
    transform: "translate(-247.035 -1375.291)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M242.837,1397.371a6.816,6.816,0,0,0-2.492,4.8l.423.038s.744-3.184,2.089-4.428S242.837,1397.371,242.837,1397.371Z",
    transform: "translate(-240.345 -1391.633)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.991)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M172.477,1336.059s4.379-2.452,2.336-5.781a8.7,8.7,0,0,0-3.387-2.569s.934,4.964,0,5.08-.642-5.605-.642-5.605-4.613-2.219-6.423-2.044c0,0,2.861,4.847,1.927,4.73s-4.146-5.022-4.146-5.022-4.73-.875-5.489,1.927.467,4.2,1.168,4.38,5.2.116,5.08.7-3.153,1.519-4.847.993c0,0,1.869,4.613,4.321,4.379s3.212-1.752,4.73-1.868,2.628.292,1.869.7-3.328.134-4.555,1.177-2.219,1.685.058,2.152,6.365.175,7.182-1.576Z",
    transform: "translate(-156.412 -1324.718)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.4 2.933)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M165.988,1336.419s12.263,3.971,13.664,8.408a9.311,9.311,0,0,0,1.168,4.263v.876s-1.285-2.978-1.986-3.387C178.835,1346.579,181.579,1342.726,165.988,1336.419Z",
    transform: "translate(-165.988 -1336.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M223.414,1385.346a8.088,8.088,0,0,1,.813,6.367l-.486-.131s.472-3.85-.517-5.787S223.414,1385.346,223.414,1385.346Z",
    transform: "translate(-208.582 -1372.675)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.236)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M236.957,1311.776s-5.773-3.233-3.079-7.62c0,0,2.155-2.694,4.465-3.386,0,0-1.232,6.543,0,6.7s.847-7.389.847-7.389,6.081-2.925,8.467-2.694c0,0-3.772,6.389-2.54,6.235s5.465-6.619,5.465-6.619,6.235-1.155,7.236,2.54-.616,5.542-1.539,5.773-6.851.153-6.7.923,4.157,2,6.389,1.309c0,0-2.463,6.08-5.7,5.773s-4.233-2.31-6.235-2.463-3.464.385-2.463.923,4.388.176,6,1.551,2.925,2.221-.077,2.837-8.39.231-9.468-2.078Z",
    transform: "translate(-233.162 -1296.826)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.746 3.865)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M261.714,1312.249s-16.164,5.234-18.012,11.084a12.283,12.283,0,0,1-1.539,5.62v1.154s1.693-3.926,2.617-4.465C244.78,1325.642,241.162,1320.562,261.714,1312.249Z",
    transform: "translate(-240.653 -1312.249)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M237.649,1376.743a10.659,10.659,0,0,0-1.072,8.393l.641-.172s-.623-5.075.682-7.628S237.649,1376.743,237.649,1376.743Z",
    transform: "translate(-236.14 -1360.04)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M213.718,1418.439a11.308,11.308,0,0,0,11.308-11.308H202.41A11.308,11.308,0,0,0,213.718,1418.439Z",
    transform: "translate(-190.881 -1379.485)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M220.622,1418.352a11.315,11.315,0,0,1-12.713-11.222h2.809A11.31,11.31,0,0,0,220.622,1418.352Z",
    transform: "translate(-195.002 -1379.484)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 23.246,
    height: 0.347,
    transform: "translate(11.157 27.646)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 7.183,
    height: 1.291,
    transform: "translate(18.984 38.243)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.49 182.61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.037 15.711)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M255.1,1366.172s-2.753-3.212-.17-5.252a7.326,7.326,0,0,1,3.426-1.049s-2.18,3.656-1.475,4.019,2.136-4.249,2.136-4.249,4.294-.416,5.676.248c0,0-3.671,3-2.9,3.183s4.738-2.77,4.738-2.77,4,.68,3.784,3.118-1.59,3.191-2.2,3.126-4.146-1.416-4.223-.921,2.054,2.117,3.547,2.193c0,0-2.818,3.107-4.69,2.21s-2.033-2.318-3.2-2.851-2.164-.532-1.682.012,2.595,1.072,3.262,2.253,1.267,1.977-.671,1.686-5.087-1.709-5.225-3.333Z",
    transform: "translate(-250.444 -1359.512)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.955)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M264.941,1375.31s-10.855-.418-13.252,2.687a7.852,7.852,0,0,1-2.161,3.033l-.254.693s1.881-1.983,2.554-2.1C251.827,1379.62,250.774,1375.774,264.941,1375.31Z",
    transform: "translate(-247.035 -1375.291)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M242.837,1397.371a6.816,6.816,0,0,0-2.492,4.8l.423.038s.744-3.184,2.089-4.428S242.837,1397.371,242.837,1397.371Z",
    transform: "translate(-240.345 -1391.633)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.991)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M172.477,1336.059s4.379-2.452,2.336-5.781a8.7,8.7,0,0,0-3.387-2.569s.934,4.964,0,5.08-.642-5.605-.642-5.605-4.613-2.219-6.423-2.044c0,0,2.861,4.847,1.927,4.73s-4.146-5.022-4.146-5.022-4.73-.875-5.489,1.927.467,4.2,1.168,4.38,5.2.116,5.08.7-3.153,1.519-4.847.993c0,0,1.869,4.613,4.321,4.379s3.212-1.752,4.73-1.868,2.628.292,1.869.7-3.328.134-4.555,1.177-2.219,1.685.058,2.152,6.365.175,7.182-1.576Z",
    transform: "translate(-156.412 -1324.718)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.4 2.933)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M165.988,1336.419s12.263,3.971,13.664,8.408a9.311,9.311,0,0,0,1.168,4.263v.876s-1.285-2.978-1.986-3.387C178.835,1346.579,181.579,1342.726,165.988,1336.419Z",
    transform: "translate(-165.988 -1336.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M223.414,1385.346a8.088,8.088,0,0,1,.813,6.367l-.486-.131s.472-3.85-.517-5.787S223.414,1385.346,223.414,1385.346Z",
    transform: "translate(-208.582 -1372.675)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.236)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M236.957,1311.776s-5.773-3.233-3.079-7.62c0,0,2.155-2.694,4.465-3.386,0,0-1.232,6.543,0,6.7s.847-7.389.847-7.389,6.081-2.925,8.467-2.694c0,0-3.772,6.389-2.54,6.235s5.465-6.619,5.465-6.619,6.235-1.155,7.236,2.54-.616,5.542-1.539,5.773-6.851.153-6.7.923,4.157,2,6.389,1.309c0,0-2.463,6.08-5.7,5.773s-4.233-2.31-6.235-2.463-3.464.385-2.463.923,4.388.176,6,1.551,2.925,2.221-.077,2.837-8.39.231-9.468-2.078Z",
    transform: "translate(-233.162 -1296.826)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.746 3.865)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M261.714,1312.249s-16.164,5.234-18.012,11.084a12.283,12.283,0,0,1-1.539,5.62v1.154s1.693-3.926,2.617-4.465C244.78,1325.642,241.162,1320.562,261.714,1312.249Z",
    transform: "translate(-240.653 -1312.249)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M237.649,1376.743a10.659,10.659,0,0,0-1.072,8.393l.641-.172s-.623-5.075.682-7.628S237.649,1376.743,237.649,1376.743Z",
    transform: "translate(-236.14 -1360.04)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M213.718,1418.439a11.308,11.308,0,0,0,11.308-11.308H202.41A11.308,11.308,0,0,0,213.718,1418.439Z",
    transform: "translate(-190.881 -1379.485)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M220.622,1418.352a11.315,11.315,0,0,1-12.713-11.222h2.809A11.31,11.31,0,0,0,220.622,1418.352Z",
    transform: "translate(-195.002 -1379.484)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 23.246,
    height: 0.347,
    transform: "translate(11.157 27.646)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 7.183,
    height: 1.291,
    transform: "translate(18.984 38.243)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(495.501 123.712)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1107.772,1061.835a2.745,2.745,0,0,0-2.745,2.745v19.61a5.245,5.245,0,0,0,3.41,4.915,3.166,3.166,0,0,1,2.027,2.722h8.438a3.325,3.325,0,0,1,1.914-2.393h0c2.063-.857,3.806-2.141,3.523-5.205v-19.5a2.893,2.893,0,0,0-2.893-2.892Z",
    transform: "translate(-1102.834 -1061.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M1.448,0H18.518a1.448,1.448,0,0,1,1.448,1.448v0A1.449,1.449,0,0,1,18.518,2.9H1.448A1.448,1.448,0,0,1,0,1.449v0A1.448,1.448,0,0,1,1.448,0Z",
    transform: "translate(1.806 14.123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M1.448,0H18.518a1.448,1.448,0,0,1,1.448,1.448v0A1.449,1.449,0,0,1,18.518,2.9H1.448A1.448,1.448,0,0,1,0,1.449v0A1.448,1.448,0,0,1,1.448,0Z",
    transform: "translate(1.806 20.252)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1131.1,1179.326h-11.922l.352-1.174a.709.709,0,0,1,.679-.505h9.793a.709.709,0,0,1,.668.471Z",
    transform: "translate(-1113.44 -1148.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M6.66,0H17.522a6.66,6.66,0,0,1,6.66,6.66V60.092a6.659,6.659,0,0,1-6.659,6.659H6.66A6.66,6.66,0,0,1,0,60.091V6.66A6.66,6.66,0,0,1,6.66,0Z",
    transform: "translate(0 30.706)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.121,
    height: 21.998,
    transform: "translate(4.072 41.033)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 16.121,
    height: 4.954,
    transform: "translate(4.072 41.033)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.034 47.796)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 2.119,
    height: 4.527
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ah",
    width: 2.119,
    height: 1.204
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.945 47.796)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 2.119,
    height: 4.527
  }), /*#__PURE__*/React.createElement("rect", {
    className: "aj",
    width: 2.119,
    height: 1.204
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1129.7,1270.063l.209,1.042a.184.184,0,0,0,.18.148h.369a.184.184,0,0,0,.18-.146l.219-1.042a.184.184,0,0,0-.18-.222h-.8A.184.184,0,0,0,1129.7,1270.063Z",
    transform: "translate(-1121.32 -1217.708)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1154.172,1270.063l.21,1.042a.184.184,0,0,0,.18.148h.369a.184.184,0,0,0,.18-.146l.219-1.042a.184.184,0,0,0-.18-.222h-.8A.184.184,0,0,0,1154.172,1270.063Z",
    transform: "translate(-1139.658 -1217.708)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 13.224,
    height: 0.546,
    transform: "translate(5.416 62.486)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.946 65.173)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1127.32,1328.834h-14.226a1.075,1.075,0,0,1-1.073-1.073v-4.823a1.074,1.074,0,0,1,1.073-1.073h14.226a1.074,1.074,0,0,1,1.073,1.073v4.823A1.074,1.074,0,0,1,1127.32,1328.834Zm-14.226-6.718a.822.822,0,0,0-.822.822v4.823a.822.822,0,0,0,.822.821h14.226a.822.822,0,0,0,.822-.821v-4.823a.823.823,0,0,0-.822-.822Z",
    transform: "translate(-1112.02 -1321.865)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.553,
    height: 0.798,
    transform: "translate(3.107 97.457)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 1.553,
    height: 0.798,
    transform: "translate(19.899 97.457)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1021.714 105.574)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M2003.223,1093.655l-10.291.05,5.194,18.484,9.9-2.052Z",
    transform: "translate(-1992.933 -1067.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M2002.9,1129.558a1.1,1.1,0,0,0-.3-.509,8.045,8.045,0,0,1-.6-1.469c-.06-.685-.524-.445-.6.156-.016.13.063.45.065.59a1.032,1.032,0,0,1-1.3-.865c-.069-.3-.176-.594-.22-.786-.064-.274-.728.182-.746.656a13.534,13.534,0,0,0,.174,3.153c.323.556,2.172,1.124,3.123,1.246l1.129.088.657-1.822Z",
    transform: "translate(-1997.63 -1092.224)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M2117.1,1430.42s-.3,4.812-1.229,4.881c-.124.009-4.722.009-4.722.009l-5.87-.033a1.906,1.906,0,0,1,1.754-1.714c1.716-.3,4.588-1.5,5.628-3.772C2113.751,1427.4,2117.1,1430.42,2117.1,1430.42Z",
    transform: "translate(-2077.119 -1318.741)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M2094.251,1258.749a12.23,12.23,0,0,1-3.177.6,11.681,11.681,0,0,1-2.967-.423,81.041,81.041,0,0,0-2.184-10.407c-.97-3.752-2.354-8.576-4.323-14.571-5.445-16.567-7.1-26.259-7.252-27.177l-.011-.073.018-.008,16.741-7.349s-2.07,22.833.57,31.6a36.991,36.991,0,0,1,.958,4.2C2094.29,1244.655,2094.251,1258.749,2094.251,1258.749Z",
    transform: "translate(-2053.934 -1146.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M2092.657,1235.135l-6.7,13.381c-.969-3.752-2.354-8.576-4.322-14.571-5.445-16.567-7.1-26.259-7.252-27.177,0-.027,0-.053.006-.081l16.74-7.349s-2.07,22.833.57,31.6A37.092,37.092,0,0,1,2092.657,1235.135Z",
    transform: "translate(-2053.968 -1146.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M2064.933,1430.42s-.3,4.812-1.229,4.881c-.124.009-4.722.009-4.722.009l-5.87-.033a1.9,1.9,0,0,1,1.754-1.714c1.716-.3,4.588-1.5,5.627-3.772C2061.587,1427.4,2064.933,1430.42,2064.933,1430.42Z",
    transform: "translate(-2038.029 -1318.741)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M2062.4,1201.485a238.384,238.384,0,0,0,2.344,32.964c2.559,18.167,1.692,25.879,1.692,25.879a17.444,17.444,0,0,0,2.468.628,11.206,11.206,0,0,0,3.664-.424s3.663-18.174,2.613-27.267,5.018-31.2,5.018-31.2Z",
    transform: "translate(-2044.982 -1148.345)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M2088.3,1040.26l-2.759,2.765-4.8.1c-.015-.386-.032-2-.047-3.455,0-.087,0-.172,0-.257l-.02-2.308,3.918-2.807,1.462-1.046c0,.026.151,1.349.174,1.541A11.25,11.25,0,0,0,2088.3,1040.26Z",
    transform: "translate(-2058.683 -1022.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M2058.5,1094.888c.067,7.81.588,26.08.972,26.451,4.068,3.927,21.96-1.076,22.909-5.4s-3.605-55.466-10.553-57.509c-1.442-.423-9.15,2.069-9.15,2.069a48.785,48.785,0,0,0-2,7.192c-.294,1.493-1.253,12.145-1.813,19.263-.148,1.9-.269,3.543-.34,4.7C2058.493,1092.126,2058.487,1093.288,2058.5,1094.888Z",
    transform: "translate(-2042.061 -1041.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M2085.917,1037.756c-.613,1.8-3.854,3.93-5.221,4.749,0-.086,0-.172,0-.256l-.02-2.308,3.918-2.806C2085.544,1036.921,2086.17,1037.014,2085.917,1037.756Z",
    transform: "translate(-2058.683 -1025.112)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M2068.414,1012.052s7.407.716,7.78-3.9,1.584-7.638-3.129-8.29-5.775,1.035-6.275,2.546S2066.5,1011.746,2068.414,1012.052Z",
    transform: "translate(-2048.104 -997.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M2065.067,994.251s1.5,4.97,2.5,4.532,1.917-.8,2.083.758-.919,3.624,2.365,3.219,6.183-9.695,4.967-11.085C2073.477,987.663,2060.212,989.477,2065.067,994.251Z",
    transform: "translate(-2046.196 -989.468)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M2077.074,1052.5c.091-.039,5.287-2.37,5.9-2.169s1.365,2.057,1.365,2.057l-9.149,2.069A4.542,4.542,0,0,1,2077.074,1052.5Z",
    transform: "translate(-2054.57 -1035.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M2058.5,1122.393c16.977-11.5,15.593-27.308,15.593-27.308-6.624,3.737-13.189,12.582-15.23,19.372-.148,1.9-.269,3.543-.34,4.7C2058.493,1119.631,2058.487,1120.793,2058.5,1122.393Z",
    transform: "translate(-2042.061 -1068.614)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M2032.482,1076.873s-4.788,16.633-6.738,16.633c-1.293,0-12.608-1.873-12.608-1.873l-1.042,2.451s12.606,8.306,17.189,6.633c7.257-2.65,11.635-15.505,10.04-19.886S2035.542,1074.98,2032.482,1076.873Z",
    transform: "translate(-2007.292 -1054.359)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.545 104.818)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M467.8,1100.781l-.17,1.893s-.125.007-.342,0c-.685-.007-2.35,0-4.239-.1a41.926,41.926,0,0,1-5.408-.51,7.929,7.929,0,0,1-2.193-.652c-2.1-1.123-5.66-4.73-8.052-8.4a2.441,2.441,0,0,1-.172-.27,18.5,18.5,0,0,1-1.882-3.687,7.727,7.727,0,0,1-.429-1.813,8.014,8.014,0,0,1,.116-2.56,6.483,6.483,0,0,1,1.014-2.363,1.13,1.13,0,0,1,.2-.275,5.38,5.38,0,0,1,1.4-1.343.9.9,0,0,1,.954.187c.039.027.076.057.115.088a.02.02,0,0,0,.006,0c.049.041.1.085.148.133v.015a4.593,4.593,0,0,1,.4.423s0,0,0,0a8.591,8.591,0,0,1,.764,1.094c.016.014.033.029.034.045.085.135.172.285.275.451a.351.351,0,0,1,.068.1q.288.521.578,1.087c2.149,4.047,4.546,10.227,6.346,12.006a12.882,12.882,0,0,0,3.053,1.631h0l.083.035.008,0c1.2.517,2.561,1.049,3.78,1.507C466.214,1100.25,467.8,1100.781,467.8,1100.781Z",
    transform: "translate(-427.489 -1057.028)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M461.9,1097.11a13.918,13.918,0,0,1-1.03,2.236c-.488.832-.627,1.505-1.433,1.973a10.629,10.629,0,0,1-6.613-3.407c-1.041-1.221-1.78-2.668-2.995-4.377-.344-.479-.674-.968-.992-1.453a2.43,2.43,0,0,1-.173-.27,18.346,18.346,0,0,1-1.88-3.686s.7-9.681,4.227-8.661c3.33.968,5.963,14.168,7.763,15.948a12.747,12.747,0,0,0,3.05,1.63l0,0C461.86,1097.086,461.884,1097.11,461.9,1097.11Z",
    transform: "translate(-428.929 -1056.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M429.731,1252.344l-2.053.764s-8.919-12.369-10.017-23.252a16.542,16.542,0,0,1,.294-5.564s-.087-.5-.24-1.377c-.071-.411-.158-.906-.256-1.472-.29-1.662-.689-3.935-1.145-6.523-1.049-5.957-2.409-13.571-3.465-19.168l.553-.177,5.986-1.931,1.237-3.929,4.458-1.173s1,1.948,1.886,11.149c.164,1.207.313,2.538.426,3.981a78.8,78.8,0,0,1-.424,16.119q-.307,2.4-.783,4.947a22.05,22.05,0,0,0-.171,4.885C426.465,1238.518,429.731,1252.344,429.731,1252.344Z",
    transform: "translate(-403.499 -1137.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M427.394,1205.7l-9.679,18.923c-.071-.4-.158-.891-.256-1.448-.29-1.634-.689-3.869-1.145-6.414-1.049-5.857-2.409-13.344-3.465-18.848l.553-.175,5.986-1.9,1.237-3.864,4.458-1.154s1,1.916,1.886,10.964C427.132,1202.976,427.281,1204.284,427.394,1205.7Z",
    transform: "translate(-403.499 -1139.601)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M396.388,1184.318l-.224-1.922c-3.754,1-13.784-2.786-13.784-2.786s-3.637,3.2-3.159,10.86c.233,3.74.659,19.633,1.1,24.337.161,1.7.3,2.918.359,3.4a.008.008,0,0,1,0,0,.669.669,0,0,1-.109.416,22.13,22.13,0,0,0-1.641,3.452c-4.364,11.629.672,25.951.672,25.951l1.307-.527s2.866-15.938,5.195-22.979a13.961,13.961,0,0,1,1.122-2.693,30.4,30.4,0,0,0,2.8-7.479,183.9,183.9,0,0,0,3.773-19.844C393.925,1194.514,396.388,1184.318,396.388,1184.318Z",
    transform: "translate(-376.751 -1131.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M424.428,1060.772c-6.287,1.5-6.612-8.217-6.215-8.239.7-.547,1.74-2.772,1.947-6.215l.3.077,4.973,1.322s-.216,1.579-.316,3.071a5.9,5.9,0,0,0,.141,2.555c.388.081.621.134.621.134a.012.012,0,0,0,0,0C425.946,1053.588,426.106,1060.372,424.428,1060.772Z",
    transform: "translate(-407.434 -1031.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M405.062,989.083c-.06-.273-.812-3.2-5.359-2.535,0,0,2.27-.139,2.831.768,0,0-1.732-.932-2.894-.32s-1.493,2.9-1.371,3.614,1.222,2.875,2.04,2.928a2.435,2.435,0,0,0,.947-.171,10.827,10.827,0,0,0-.41,1.193c-1.13,4.029,1.387,7.308,2.841,6.631.932-.434,1.513,1.186,1.513,1.186l8.111-9.428S408.5,986.356,405.062,989.083Z",
    transform: "translate(-392.556 -986.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M432.48,1047.951s-.216,1.578-.315,3.071c-2.814-.26-4.139-2.927-4.658-4.392Z",
    transform: "translate(-414.483 -1031.547)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M431.543,1023.579s-6.677-.318-6.415-4.473-.423-6.995,3.851-6.967,5,1.666,5.251,3.074S433.286,1023.554,431.543,1023.579Z",
    transform: "translate(-412.695 -1005.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M427.9,1010.323c-.951-1.316-1.748-1.092-2.208-.744a4.672,4.672,0,0,0-6.056.574,7.955,7.955,0,0,1-2.9,4.522s1.167.829,4.017.288a4.769,4.769,0,0,0,2.371-1.421,15.589,15.589,0,0,1-2.888,3.1c3.447-1.332,5.09-5.9,5.256-6.386a5.238,5.238,0,0,1,1.33,2.031c.264,1.08.274,3.267.914,3.234C427.735,1015.521,429.323,1012.3,427.9,1010.323Z",
    transform: "translate(-406.413 -1003.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M386.161,1439.432H375.819a5.678,5.678,0,0,1,.292-2.772c.518-1.148,1.328-1.669,1.134-3.058a3.723,3.723,0,0,0,3.223,1.234,11.347,11.347,0,0,0,1.794,2.326C382.939,1437.648,385.953,1437.475,386.161,1439.432Z",
    transform: "translate(-375.708 -1321.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M474.6,1440.819H464.255a4.3,4.3,0,0,1,.292-2.772,1.993,1.993,0,0,0-.074-2.38,4.013,4.013,0,0,0,1.742.328,3.641,3.641,0,0,0,1.538-.541,37.117,37.117,0,0,0,2.947,3.1C471.376,1439.035,474.389,1438.862,474.6,1440.819Z",
    transform: "translate(-441.94 -1322.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M397.629,1073.012l2.405,22.71,1.473,13.905c-1.481.773-2.905,1.427-4.269,1.977a16.972,16.972,0,0,0-.924-2.441,7.421,7.421,0,0,1-.81,3.094c-12.65,4.456-19.791-.117-19.791-.117-.408-5.123-.062-15.7,1.015-24.707.225-1.874.48-3.679.768-5.355a70.218,70.218,0,0,1,1.582-7.4c.837-2.991,6.842-3.9,6.842-3.9a14.859,14.859,0,0,0,5.536,5.948c1.505-1.3,2.128-5,2.128-5Z",
    transform: "translate(-375.547 -1049.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M418.11,1066.765s-1.071.27-1.177,1.005c0,0,2.45,5.437,5.534,5.948Z",
    transform: "translate(-406.56 -1046.635)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M439.015,1077.579s1.885-4.988,1.752-5.661c0,0,1.2.231,1.252.936C442.019,1072.854,440.367,1077.011,439.015,1077.579Z",
    transform: "translate(-423.108 -1050.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M422.067,1111.348c.127.255,6.427,11.547,12.828,14.776,2.821,1.423-6.735-.463-6.876-.855S422.067,1111.348,422.067,1111.348Z",
    transform: "translate(-410.407 -1080.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M422.84,1132.374l1,9.484c-16.143,0-17.864-22.17-17.864-22.17l8.982,9.8,7.783,2.791Z",
    transform: "translate(-398.353 -1086.294)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M418.181,1106.357l-.275,2.043s-.694-.033-1.8-.088c-.332-.019-.523-.041-.523-.041-.885-.052-1.947-.145-3.1-.241l-.016,0c-1.987-.2-4.217-.468-6.117-.841-.171-.036-.339-.071-.5-.107a14.884,14.884,0,0,1-2.827-.873,1.909,1.909,0,0,1-.237-.124c-1.977-1.068-4.634-4.63-6.852-8.534-.307-.538-.6-1.08-.889-1.605a42.473,42.473,0,0,1-2.542-5.617,16.755,16.755,0,0,1-.79-2.731,6.742,6.742,0,0,1-.12-.783c-.57-4.47,2.526-5.356,3.01-4.9a14.158,14.158,0,0,1,2.039,2.69c1.144,1.868,2.413,4.316,3.619,6.757.666,1.338,1.316,2.678,1.952,3.909.368.75.729,1.453,1.066,2.1a21.411,21.411,0,0,0,1.7,2.829,7.514,7.514,0,0,0,2.124,1.456c.273.147.565.3.871.452,1.7.849,3.842,1.762,5.737,2.518.929.377,1.805.715,2.532.993C417.4,1106.068,418.181,1106.357,418.181,1106.357Z",
    transform: "translate(-387.514 -1057.908)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M407.962,1102.1a6.406,6.406,0,0,1-2.63,5.988c-4.225-.913-7.187-6.633-9.405-10.538-.307-.538-.6-1.08-.889-1.605a42.473,42.473,0,0,1-2.542-5.617,16.755,16.755,0,0,1-.79-2.731,6.742,6.742,0,0,1-.12-.783c-.57-4.47,2.526-5.356,3.01-4.9a14.158,14.158,0,0,1,2.039,2.69c1.144,1.868,2.413,4.316,3.619,6.757.666,1.338,1.316,2.678,1.952,3.909.368.75.729,1.453,1.066,2.1a21.411,21.411,0,0,0,1.7,2.829,7.514,7.514,0,0,0,2.124,1.456C407.364,1101.8,407.657,1101.95,407.962,1102.1Z",
    transform: "translate(-387.514 -1057.908)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M518.918,1141.774c0,.017-.006.026-.016.028,0-.013.005-.023.007-.031C518.917,1141.745,518.919,1141.744,518.918,1141.774Z",
    transform: "translate(-482.972 -1102.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M518.086,1160.283l-13.08.08,8.672-14.291,13.08-.08Z",
    transform: "translate(-472.559 -1106.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M500.1,1179.537a10.454,10.454,0,0,1-2.994-.728,7.16,7.16,0,0,1,.675-.3l.484-.8a6.437,6.437,0,0,1-2.094.243,3.83,3.83,0,0,0-1.714.686c-1-.179-1.9-.415-2.189-.493a.468.468,0,0,1-.107-.036l-1.349,2.082s.92.106,1.243.183c.813.24,2.091,1,3.72,1.542.932.311,2.633-.21,3.645-.585a2.908,2.908,0,0,0,1.559-1.292C501.285,1179.463,500.625,1179.564,500.1,1179.537Z",
    transform: "translate(-461.925 -1129.776)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M475.813,1136.789a10.632,10.632,0,0,1-6.613-3.407l-.562-6.66C468.714,1127.228,470.023,1135.327,475.813,1136.789Z",
    transform: "translate(-445.306 -1091.565)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(950.712 130.463)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1882.864,1218.867a16.588,16.588,0,0,1,2.077-1.6c.542-.247,1.53-1.224,1.714-.894s-.625.974-.53,1.366,2.908.7,2.943,1.119a1.628,1.628,0,0,1-1.527,1.526c-1.058.011-3.79-.239-4.589-.116C1882.348,1220.36,1882.864,1218.867,1882.864,1218.867Z",
    transform: "translate(-1839.296 -1184.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1777.266,1168.438s1.631-.741,6.724,3.863,8.581,9.418,11.3,9.627,8.833.734,8.833.734l.877,1.692s-.218.73-4.529,2.1a20.444,20.444,0,0,1-7.529.844c-3.488-.419-11.849-6.005-13.121-7.679S1777.266,1168.438,1777.266,1168.438Z",
    transform: "translate(-1760.318 -1148.437)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.117 9.464)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1916.694,1306.661a16,16,0,0,0,.163,3.343c.686,5.5,2.927,14.283,2.927,14.283l2.807.34c-.205-1.553.379-7.5,1.156-14.091,1.17-9.944,2.779-21.353,2.779-21.353s-6.111-5.05-9.712-3.655S1917.117,1302.808,1916.694,1306.661Z",
    transform: "translate(-1906.855 -1245.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M1921.589,1383.912c.686,5.5,2.927,14.282,2.927,14.282l2.807.34c-.205-1.553.38-7.5,1.156-14.092a12.32,12.32,0,0,1-5.977-.329A2.817,2.817,0,0,0,1921.589,1383.912Z",
    transform: "translate(-1911.586 -1319.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M1931.273,1137.033a4.081,4.081,0,0,1,3.141,0c1.661.71,2.87,3.734,2.126,6.559s1.767,2.872.6,5.138c-.412.8-5.871,1.487-6.057-1.642-.116-1.939,1.639-2.034,1.127-4.141S1931.273,1137.033,1931.273,1137.033Z",
    transform: "translate(-1918.699 -1134.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M1899.143,1304.64a20.052,20.052,0,0,0,.039,4.4c.478,5.606,2,13.619,2,13.619l2.776.641c-.106-1.533.8-7.3,1.945-13.756,1.779-10.04,4.13-21.74,4.13-21.74s-5.789-5.419-9.469-4.247S1899.8,1300.82,1899.143,1304.64Z",
    transform: "translate(-1894.407 -1244.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "M1931.946,1438.811a3.281,3.281,0,0,0,1.938,1.509,3.184,3.184,0,0,1,1.908,1.187.746.746,0,0,1-.606,1.186l-6.459-.036a.928.928,0,0,1-.918-1.027c.051-.478.1-1.035.129-1.463a3.074,3.074,0,0,1,1.063-1.77,6.586,6.586,0,0,0,1.228.568A4.583,4.583,0,0,0,1931.946,1438.811Z",
    transform: "translate(-1916.243 -1360.231)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1944.024,1191.8s4.22,7.115,5.071,12.916c0,0-2.052,2.77-2.887.825S1939.381,1193.182,1944.024,1191.8Z",
    transform: "translate(-1927.09 -1175.437)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M1911.439,1130.257a8.669,8.669,0,0,0-5.463-3.657A5.22,5.22,0,0,0,1900,1131c-.442,2.88.009,6.613,4.708,7.957Z",
    transform: "translate(-1895.309 -1126.528)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1922.676,1170.857l-5.318,3.159-1.344-3.744a11.691,11.691,0,0,0,.8-3.546,14.565,14.565,0,0,0-.085-3.147l4.624,2.009a8.54,8.54,0,0,0-.113,1.036,7.467,7.467,0,0,0,.23,2.392A3.319,3.319,0,0,0,1922.676,1170.857Z",
    transform: "translate(-1907.408 -1154.294)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M1923.837,1178.121c-2.552.094-4.656-2.29-4.656-2.29l4.426-.1A7.452,7.452,0,0,0,1923.837,1178.121Z",
    transform: "translate(-1909.781 -1163.397)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1918.459,1148.452s-4.995,1.664-7-2.263c-2.169-4.239-.3-7.548,1.415-7.872,3.413-.647,5.495.539,6.187,1.886S1921.217,1147.558,1918.459,1148.452Z",
    transform: "translate(-1903.259 -1135.226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1933.712,1168.387s.246.511,1.568.131c0,0,1.109-.319.944-.9A3.709,3.709,0,0,0,1933.712,1168.387Z",
    transform: "translate(-1920.671 -1157.307)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M1891.766,1230.806c1.444,1.379,12.1,4.23,18.113,2.181,1.076-.367-.646-33.59-1.673-40.005a4.042,4.042,0,0,0-3.445-3.368q-.448-.061-.97-.114c.074.789-.2,1.531-1.571,1.8a5.518,5.518,0,0,1-4.449-1.6,16.911,16.911,0,0,0-3.4.883,2.993,2.993,0,0,0-1.809,3.159l.344,2.533,1.095,8.071a10.672,10.672,0,0,1-.023,3.053c-.466,3.068-1.207,10.54-1.7,16.224C1891.921,1227.622,1891.693,1230.735,1891.766,1230.806Z",
    transform: "translate(-1889.227 -1173.717)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M1911.867,1134.437s.473,4.685-3.972,6.346c-1.767.661-2.687-6.5,1.006-7.925s7.336.269,7.771,2.766.1,3.019.1,3.019S1915.047,1133.89,1911.867,1134.437Z",
    transform: "translate(-1900.167 -1130.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1902.055,1197.045s2.038,8.063,2.118,11.27c0,0,4.474,7.814,4.736,8.369s-1.615,1.315-1.615,1.315-5.612-5.986-6.694-8.5-4.92-10.7-3.384-13.137S1902.055,1197.045,1902.055,1197.045Z",
    transform: "translate(-1893.053 -1178.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1956.166,1243.311a14.4,14.4,0,0,1-3.508,9.82s-1.067-1.285-.933-1.683,1.665-6.52,2.782-7.391S1956.166,1243.311,1956.166,1243.311Z",
    transform: "translate(-1934.16 -1214.036)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1940.113,1280.235s2.5-.018,2.642.57a1.81,1.81,0,0,1-2.473,1.788c-1.829-.642-1.783-1.042-1.783-1.042Z",
    transform: "translate(-1924.257 -1241.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1947.369,1275.793s-2.01.929-1.327,1.919a1.342,1.342,0,0,0,2.26-.235C1948.513,1276.843,1947.369,1275.793,1947.369,1275.793Z",
    transform: "translate(-1929.804 -1238.382)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M1901.691,1200.952a9.142,9.142,0,0,1-6.669,2.062s-1.993-7.065,1.2-7.932S1902.063,1198.4,1901.691,1200.952Z",
    transform: "translate(-1891.217 -1177.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M1953.05,1196.764l2.312,3.954a2.444,2.444,0,0,1-2.029,2.018C1951.6,1202.918,1953.05,1196.764,1953.05,1196.764Z",
    transform: "translate(-1934.737 -1179.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M1887.862,1137.073a3.668,3.668,0,0,0-3.141,0c-1.661.8-2.87,4.2-2.126,7.386s-1.767,3.234-.6,5.784c.412.9,5.872,1.675,6.058-1.849.115-2.182-1.639-2.29-1.128-4.662S1887.862,1137.073,1887.862,1137.073Z",
    transform: "translate(-1881.678 -1134.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M1900.73,1385.727c.478,5.606,2,13.618,2,13.618l2.777.641c-.106-1.533.8-7.3,1.945-13.757A17.674,17.674,0,0,1,1900.73,1385.727Z",
    transform: "translate(-1895.955 -1320.762)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M1907.718,1438.811a3.28,3.28,0,0,0,1.937,1.509,3.183,3.183,0,0,1,1.908,1.187.747.747,0,0,1-.607,1.186l-6.458-.036a.929.929,0,0,1-.918-1.027c.051-.478.1-1.035.129-1.463a3.073,3.073,0,0,1,1.063-1.77,6.6,6.6,0,0,0,1.229.568A4.584,4.584,0,0,0,1907.718,1438.811Z",
    transform: "translate(-1898.087 -1360.231)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M1743.473,1094.473s.094-3.318-4.282-3.969-5.586.372-6.33,1.488a19.528,19.528,0,0,0-2,7.488c.139,1.814,5.131,4.056,5.05,5.115S1743.473,1094.473,1743.473,1094.473Z",
    transform: "translate(-1725.536 -1089.916)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1856.866,1422.561c-.088,1.108,1.456,1.356,3.24,1.422s1.251.438,3.7.849,3.421-.271,3.593-.6c.154-.3-.989-.739-2.206-1.24-.154-.063-.307-.127-.461-.192-1.371-.581-2.151-1.794-3.228-2.913-1.021-1.06-2.021-4.484-2.021-4.484l-3.33-.666s.973,3.081,1.314,4.4a4.1,4.1,0,0,1-.31,2.31A4.346,4.346,0,0,0,1856.866,1422.561Z",
    transform: "translate(-1819.433 -1333.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M1862.228,1444.038c1.784.065,1.25.438,3.7.848s3.42-.27,3.593-.6c.154-.295-.989-.738-2.206-1.24l-.019.02a6.96,6.96,0,0,1-3.7.093c-1.622-.418-3.2-1.364-4.316-1.662a4.376,4.376,0,0,0-.291,1.122C1858.9,1443.724,1860.444,1443.973,1862.228,1444.038Z",
    transform: "translate(-1821.554 -1353.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M1742.77,1271.63s22.1,1.16,25.891,4.289,4.658,33.979,4.658,33.979c-.536.6-.953.61-1.848.585a12.616,12.616,0,0,1-2.639-.661s-5.455-14.9-5.687-18.4-1.268-9.41-2.781-9.687-19.222,2.561-21.446-2.869a11.758,11.758,0,0,1,.793-10.136Z",
    transform: "translate(-1730.97 -1223.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1713.049,1201.029c.95.636,3.406.988,6.256,1.089,5.1.186,11.466-.422,12.719-1.606a2.158,2.158,0,0,0,.529-1.454c.138-1.957-.8-5.177-1.425-7.842a10.068,10.068,0,0,1-.457-3.992c.692-2.327,2.842-7.069,3.028-8.627s-1.674-9.909-4.246-10.943-12.5,0-12.5,0c-3.877.787-4.04,9.053-2.753,16.089.034.181.067.361.1.54C1715.7,1191.428,1710.4,1199.253,1713.049,1201.029Z",
    transform: "translate(-1711.632 -1147.538)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.731 3.907)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1753.565,1150.8c-.07.453-1.311,1.189-3.964.49-2.542-.67-2.847-1.5-2.846-2.045,0-.647,1.1-1.519,1.09-5.5l.306.06,5.125,1.014s-.117,1.613-.12,3.133C1753.152,1149.232,1753.681,1150.05,1753.565,1150.8Z",
    transform: "translate(-1745.185 -1133.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M1757.447,1145s-.117,1.613-.12,3.133c-2.867-.081-4.384-2.7-5-4.147Z",
    transform: "translate(-1749.357 -1134.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1756.062,1119.545s-6.785.112-6.79-4.115-.884-7.058,3.448-7.309,5.176,1.362,5.521,2.772S1757.827,1119.407,1756.062,1119.545Z",
    transform: "translate(-1747.014 -1107.159)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M1749.288,1105.217s-1.858,4.959-4.709,5.692-4.088-.031-4.088-.031a8.071,8.071,0,0,0,2.641-4.77S1747.886,1102.857,1749.288,1105.217Z",
    transform: "translate(-1740.491 -1104.358)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M1773.752,1106.975a5.991,5.991,0,0,1,1.726,2.184c.338,1.076.49,3.292,1.136,3.216,0,0,1.4-3.37-.173-5.277C1774.773,1105.076,1773.752,1106.975,1773.752,1106.975Z",
    transform: "translate(-1765.416 -1105.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1770.573,1142.528s.126.537,1.462.454c0,0,1.122-.069,1.087-.659A3.606,3.606,0,0,0,1770.573,1142.528Z",
    transform: "translate(-1763.033 -1132.704)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1800.731,1419.667c.039,1.11,1.6,1.183,3.381,1.046s1.292.294,3.772.424,3.367-.656,3.5-1.006c.119-.31-1.066-.622-2.333-.983-.16-.045-.319-.092-.479-.139-1.428-.423-2.341-1.539-3.538-2.528-1.134-.938,1.025-5.852,1.025-5.852l-3.215-1.372s-.427,3.453-1.046,6.486c-.16.784-.743,2.09-.907,2.777A4.361,4.361,0,0,0,1800.731,1419.667Z",
    transform: "translate(-1777.901 -1328.931)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M1713.049,1239.339c.95.636,3.406.988,6.256,1.089,4.7-1.07,10.061-2.316,13.247-3.06.138-1.957-.8-5.178-1.425-7.842-3.715,1.134-9.244-2.73-11.1-4.258-1.953-1.6-1.892-6.951-1.892-6.951l-3.93,3.737c.034.181.067.361.1.54C1715.7,1229.738,1710.4,1237.563,1713.049,1239.339Z",
    transform: "translate(-1711.632 -1185.847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M1804.111,1448.409c1.78-.137,1.292.293,3.772.424s3.367-.656,3.5-1.006c.119-.311-1.066-.622-2.333-.983l-.016.023a6.961,6.961,0,0,1-3.667.511c-1.659-.232-3.332-.993-4.476-1.162a4.358,4.358,0,0,0-.162,1.147C1800.769,1448.473,1802.331,1448.546,1804.111,1448.409Z",
    transform: "translate(-1777.901 -1356.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M1718.071,1283.306c5.576-.431,22.317.057,25.638,2.272,4.087,2.727-5.767,33.973-5.767,33.973h-3.162s-1.839-18.143-.7-21.765c1.054-3.346,1.743-4.546.209-4.667s-20.434,3.2-22.3-2.365a13.765,13.765,0,0,1,.174-8.514S1712.927,1283.7,1718.071,1283.306Z",
    transform: "translate(-1710.951 -1233.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M1732.351,1091.025s.279-1.771-2.177-2.228-2.5,4.759-2.765,6.017.393,2.011,1.33,2.087S1732.351,1091.025,1732.351,1091.025Z",
    transform: "translate(-1722.914 -1088.768)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.88 46.615)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1774.333,1278.251s3.584-.4,4.362-.036,3.263,2.678,2.786,3.114-2.8-.776-3.962-.813-2.126.376-2.922.119a9.6,9.6,0,0,1-1.594-.719Z",
    transform: "translate(-1773.004 -1277.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1778.307,1275.772a13.04,13.04,0,0,0,2.376-.992.136.136,0,0,1,.2.059c.094.222.148.631-.5.92A3.205,3.205,0,0,1,1778.307,1275.772Z",
    transform: "translate(-1776.978 -1274.754)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1714.971,1168.994s-3.883.329-4.186,3.4c-.23,2.33-1.919,18.862-.7,20.3,3.423,4.046,11.071,5.234,15.443,5.482a6.934,6.934,0,0,0,.813-.726,4.153,4.153,0,0,0,.517-.94s-11.978-6.351-11.791-7.746S1718.7,1168.441,1714.971,1168.994Z",
    transform: "translate(-1709.647 -1148.877)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(709.366 70.438)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1714.83,849.28v50.4h70.84v-50.4Zm69.958,49.513h-69.075V850.162h69.075Z",
    transform: "translate(-1714.83 -849.28)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(819.307 70.438)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2153.48,849.28v50.4h35.864v-50.4Zm34.979,49.513h-34.1V850.162h34.1Z",
    transform: "translate(-2153.48 -849.28)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M0,0H1286.887V239.686L141.526,250.5,0,239.686Z",
    transform: "translate(0 21.797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundImage);
export default __webpack_public_path__ + "static/media/backgroundImage.f6bd509568c819a084f2bc370bd60545.svg";
export { ForwardRef as ReactComponent };